import React, { Component } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

class Steps extends Component {

    names = ["Behandeling" ,"Datum", "Tijdstip", "Bevestigen"];
    circularProgressStyle = {
        root: {},
        path: {
          stroke: '#f14668',
          strokeLinecap: 'butt',
          transition: 'stroke-dashoffset 0.5s ease 0s',
          transform: 'rotate(0.25turn)',
          transformOrigin: 'center center',
        },
        trail: {
          stroke: '#feecf0',
          strokeLinecap: 'butt',
          transform: 'rotate(0.25turn)',
          transformOrigin: 'center center',
        },
        text: {
          fill: '#363636',
          fontSize: '18px',
        },
        background: {
          fill: '#3e98c7',
        },
      }
    
    content() {
        let steps = [];
        let step = 1;
        for(let i = 0; i < 4; i++) {
            if (step < this.props.step) {
                steps.push(
                    <li className="steps-segment" key={i}>
                        <a href="#" className="steps-marker is-danger">{step}</a>
                        <div className="steps-content">{this.names[step - 1]}</div>
                    </li>
                );
                step++;
            } else if (step === this.props.step) {
                steps.push(
                    <li className="steps-segment is-active is-not-completed" key={i}>
                        <span className="steps-marker is-danger is-hollow">{step}</span>
                        <div className="steps-content">{this.names[step - 1]}</div>
                    </li>
                );
                step++;
            } else {
                steps.push(
                    <li className="steps-segment is-not-completed" key={i}>
                        <span className="steps-marker has-background-danger-light">{step}</span>
                        <div className="steps-content">{this.names[step - 1]}</div>
                    </li>
                );
                step++;
            }
        }
        return steps;   
    }

    renderSmallNextStep = () => {
        if (this.props.step < 4) {
            return "volgende stap: " + this.names[this.props.step];
        } 
    }

    render() {
        return (
            <div className="columns steps">
                <div className="column">
                    <div style={{marginBottom: "10px"}}>
                        <div className="steps-large">
                            <ul className="steps is-centered has-content-centered has-gaps">
                                {this.content()}
                            </ul>
                        </div>
                        <div className="steps-small">
                            <div className="progress-circle">
                                <CircularProgressbar 
                                    value={this.props.step / 4} 
                                    maxValue={1} 
                                    text={this.props.step + " van 4" }
                                    strokeWidth={12}
                                    styles={this.circularProgressStyle}
                                    />
                            </div>
                            <div className="steps-text is-pulled-right">
                                <div className="steps-text-current">
                                    {this.names[this.props.step - 1]}
                                </div>
                                <div className="steps-text-next">
                                    {this.renderSmallNextStep()}  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Steps;